import * as React from "react";
import { useCallback } from "react";
import { useFormikContext } from "formik";
import { Button } from "components/bootstrap";
import { Row } from "common/components/layout-styles";
function FormButtons({ onRemove, isEdit = false, saving = false, onCancel = void 0 }) {
  const { resetForm, isValid, dirty, submitForm } = useFormikContext();
  const handleOnCancel = useCallback(() => {
    resetForm();
    onCancel == null ? void 0 : onCancel();
  }, [onCancel, resetForm]);
  return /* @__PURE__ */ React.createElement(Row, { $justify: "flex-end" }, /* @__PURE__ */ React.createElement(Button, { type: "reset", onClick: handleOnCancel }, "Cancel"), isEdit && /* @__PURE__ */ React.createElement(Button, { bsStyle: "danger", onClick: onRemove }, "Remove"), /* @__PURE__ */ React.createElement(Button, { type: "button", bsStyle: "primary", onClick: submitForm, disabled: !isValid || !dirty || saving }, isEdit ? "Save" : "Create", " Event Procedure"));
}
export default FormButtons;
